import React, {useEffect, useState} from 'react'
import axios from 'axios'
import {QRCodeCanvas} from 'qrcode.react'
import {useParams} from 'react-router-dom'

const API_URL = process.env.REACT_APP_API_URL
const GET_SCHEDULE_BY_CLASS_URL = `${API_URL}/Custom/GetUniversityWeeklyScheduleByClass`

interface ScheduleItem {
  id: number
  day: number
  startTime: string
  endTime: string
  courseName: string
  courseCode?: string
  classroomName: string
  name?: string
  detail?: string
}

const dayNames = ['Pazartesi', 'Salı', 'Çarşamba', 'Perşembe', 'Cuma', 'Cumartesi', 'Pazar']
const dayColors = [
  'bg-primary',
  'bg-secondary',
  'bg-success',
  'bg-danger',
  'bg-warning',
  'bg-info',
  'bg-dark',
]

const PublicUniversityCourseSchedulePrint: React.FC = () => {
  const {semesterId, departmentId, classId} = useParams()
  const [schedule, setSchedule] = useState<ScheduleItem[]>([])

  useEffect(() => {
    if (!semesterId || !departmentId || !classId) return
    axios
      .get(
        `${GET_SCHEDULE_BY_CLASS_URL}?semesterId=${semesterId}&classId=${classId}&departmentId=${departmentId}`
      )
      .then((res) => setSchedule(res.data || []))
      .catch(console.error)
  }, [semesterId, departmentId, classId])

  const renderTable = () => {
    if (!schedule.length) return null
    const grouped = schedule.reduce((acc: Record<number, ScheduleItem[]>, item) => {
      if (!acc[item.day]) acc[item.day] = []
      acc[item.day].push(item)
      return acc
    }, {})
    return (
      <div className='row'>
        {Object.entries(grouped).map(([day, items]) => (
          <div key={day} className='col-md-6 col-lg-4 mb-4'>
            <h5 className={`p-2 rounded text-center text-white ${dayColors[Number(day) - 1]}`}>
              {dayNames[Number(day) - 1]}
            </h5>
            <table className='table table-bordered table-hover'>
              <thead className='table-light'>
                <tr>
                  <th className='text-center'>Saat</th>
                  <th>Ders</th>
                  <th>Tür</th>
                  <th>Sınıf</th>
                  <th>Açıklama</th>
                </tr>
              </thead>
              <tbody>
                {items.map((i) => (
                  <tr key={i.id}>
                    <td className='text-center'>
                      <span className='badge bg-info'>
                        {i.startTime} - {i.endTime}
                      </span>
                    </td>
                    <td>{i.courseCode ? `${i.courseName} (${i.courseCode})` : i.courseName}</td>
                    <td>{i.name ? i.name.split(' - ').pop() : ''}</td>
                    <td>{i.classroomName}</td>
                    <td>{i.detail || ''}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        ))}
      </div>
    )
  }

  const currentUrl = `${window.location.origin}/program/print/${semesterId}/${departmentId}/${classId}`

  return (
    <div className='container mt-4'>
      <style>{`@media print { @page { size: A4 landscape; } }`}</style>
      <div className='d-flex justify-content-between align-items-center mb-4'>
        <h2>Haftalık Ders Programı</h2>
        <QRCodeCanvas value={currentUrl} size={96} />
      </div>
      {renderTable()}
      <div className='text-end mt-4'>
        <button className='btn btn-primary' onClick={() => window.print()}>
          Yazdır
        </button>
      </div>
    </div>
  )
}

export default PublicUniversityCourseSchedulePrint

